import { createSelector } from "@reduxjs/toolkit";

export const selectBooks = (state) => state.books;
export const selectBooksData = (state) => state.books.books;
export const selectBooksLoading = (state) => state.books.loading;
export const selectBooksError = (state) => state.books.error;
export const selectBooksStatus = (state) => state.books.status;

export const selectCurrentBook = (currentLangId) =>
  createSelector([selectBooksData], (books) =>
    books.find((book) => book.language_id === currentLangId)
  );

// state.filters.selectedLanguages is an array of language names
// state.langauges.languages is available
/// state.books.books is an array of book each with a lanugage ID
export const selectSelectedBooks = (state) => {
  const { selectedLanguages } = state.filters;
  const { languages } = state.languages;
  const { books } = state.books;

  // Create a Set of selected language IDs for efficient lookup
  const selectedLanguageIds = new Set(
    languages
      .filter((lang) => selectedLanguages.includes(lang.name))
      .map((lang) => lang.id)
  );

  // Return books that have a language ID present in the selectedLanguageIds Set
  return books.filter((book) => selectedLanguageIds.has(book.language_id));
};

export const selectFetchedBookIds = (state) => {
  return state.books.fetchedBookIds;
};
